import {isUndefined} from 'lodash';
import {Grid, Link, Theme, Typography, useMediaQuery} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from 'react-i18next';

import MapAporia from 'src/Assets/Images/map_aporia.png?quality=85&ignore';
import {mapStyles} from 'src/Components/Common/FooterBar/mapStyles';
import EnvHelper from 'src/Utils/EnvHelper';

const Map = (props: IContactUsProps) => {
	const phoneNumber = EnvHelper.getAporiaPhone();
	const showPhone = props.i18n.language === 'ru' && !isUndefined(phoneNumber);

	return (
		<Grid className={props.classes.mapWrapper} xs={12} sm={4} item md={3}>
			<img alt="map" src={MapAporia} className={props.classes.mapAporia} />
			<Typography variant="h3" className={props.classes.description}>
				{useMediaQuery((theme: Theme) =>
					theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)
				)
					? props.t('mapdescription.mobile')
					: props.t('mapdescription')}
			</Typography>
			<Link className={props.classes.email} href={`mailto:${EnvHelper.getAporiaEmail()}`}>
				{EnvHelper.getAporiaEmail()}
			</Link>
			{showPhone && (
				<>
					<br />
					<Link className={props.classes.email} href={`tel:${phoneNumber}`}>
						{phoneNumber}
					</Link>
				</>
			)}
		</Grid>
	)
};

interface IContactUsProps extends WithTranslation, WithStyles {
}

export default withStyles(mapStyles)(withTranslation('contactus')(Map));
